module.exports = __webpack_public_path__ + "static/peppers-web-daaa9244f9d6069e849c57098dd7747b.jpg";